import { SvgSpinner } from '@icons/oldIcons/SvgSpinner';
import { twMerge } from 'tailwind-merge';

export default function FullScreenLoading({
  isDerma = false,
  className = '',
}: {
  isDerma?: boolean;
  className?: string;
}) {
  const classes = isDerma ? 'text-derma-primary' : 'text-hg-secondary';

  return (
    <div
      className={twMerge(
        `absolute flex inset-0 justify-center items-center bg-white/50 backdrop-blur-sm ${className}`
      )}
    >
      <SvgSpinner className={classes} />
    </div>
  );
}
